import { FlowProvider } from "@b2bportal/core-utilities";

export enum CoreFlightExchangeSteps {
  HOME = "HOME",
  DEPARTURE = "DEPARTURE",
  RETURN = "RETURN",
  REVIEW = "REVIEW",
  REVIEW_FARE = "REVIEW_FARE",
  CHECKOUT = "CHECKOUT",
}

const FlightExchangeSteps = {
  ...CoreFlightExchangeSteps,
} as const;
export type FlightExchangeSteps =
  (typeof FlightExchangeSteps)[keyof typeof FlightExchangeSteps];

export const FlightExchangeNavigationFlowProvider = ({
  children,
  navigationFlow,
}) => {
  return (
    <FlowProvider<FlightExchangeSteps> flow={navigationFlow}>
      {children}
    </FlowProvider>
  );
};
